import React, { useState, useEffect } from 'react';
import useAxios from '../api/axios';
import { toast } from 'react-toastify';
import { ACTIVITY_ID } from '../constants/activity';
import bgImage from '../assets/bg.jpg';

const PricesPage = () => {
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const api = useAxios();

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await api.get(`/getPrices.php?activityID=${ACTIVITY_ID}`);
        console.log('Prices response:', response.data);
        setPrices(response.data);
      } catch (error) {
        console.error('Error fetching prices:', error);
        toast.error('Virhe hintojen hakemisessa');
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, [api]);

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Ladataan...</div>;
  }

  if (!prices || !Array.isArray(prices) || prices.length === 0) {
    return <div className="flex justify-center items-center h-screen">Ei hintoja saatavilla</div>;
  }

  const formatSpot = (spot) => {
    if (spot === null || spot === undefined) return '';
    const normalized = `${spot}`.trim();
    const parsed = parseInt(normalized, 10);
    return Number.isNaN(parsed) ? normalized : parsed.toString();
  };

  // Format size as '4x4m' -> '4m x 4m'
  const formatSize = (size) => {
    if (!size) return '-';
    // Replace comma with dot for decimals, then split by 'x' or 'X'
    const parts = size.replace(/,/g, '.').split(/x/i);
    if (parts.length === 2) {
      return `${parts[0].trim()}m x ${parts[1].trim()}`;
    }
    return size;
  };

  const spotListString = (spots) => {
    if (!Array.isArray(spots) || spots.length === 0) return '-';
    return spots
      .map(formatSpot)
      .filter((x) => x !== '')
      .join(', ');
  };

  const getSortKey = (size) => {
    if (!size) return 0;
    const match = size.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  };

  // Sort prices by the numeric value before 'x' in size
  const sortedPrices = [...prices].sort((a, b) => {
    const sizeA = a.size || '';
    const sizeB = b.size || '';
    return getSortKey(sizeA) - getSortKey(sizeB);
  });

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="min-h-screen">
        <div className="max-w-3xl mx-auto">
      <h1 className="text-5xl font-bold text-center mb-8 text-gray-700 [text-shadow:_-1px_-1px_0_#fff,_1px_-1px_0_#fff,_-1px_1px_0_#fff,_1px_1px_0_#fff]">Hinnasto</h1>

      <div className="mb-6 text-center text-base text-gray-700 bg-white/95 border-4 border-blue-500 rounded-lg px-4 py-3 shadow-sm">
        Sähköstä, valovirta 230 V tai voimavirta 400 V, veloitamme <span className="font-bold text-blue-700">15&nbsp;€</span> / paikka.
      </div>

      <div className="overflow-x-auto">
        <div className="min-w-full bg-white/95 shadow-lg rounded-xl border-4 border-blue-500">
          <div className="grid grid-cols-3 font-semibold bg-blue-100 rounded-t-xl text-blue-900 text-center text-base">
            <div className="py-3 px-2 border-r border-blue-200">Koko</div>
            <div className="py-3 px-2 border-r border-blue-200">Hinta</div>
            <div className="py-3 px-2">Paikat</div>
          </div>
          {sortedPrices.map((price, index) => {
            const sizeRaw = price.size || price.spotSize || price.width || '-';
            const size = formatSize(sizeRaw);
            const priceValue = price.prize || price.fixedPrice || price.price || 0;
            const spotsText = spotListString(price.spots);
            const isEven = index % 2 === 0;
            return (
              <div
                key={index}
                className={`grid grid-cols-3 text-center items-center px-2 py-3 text-base border-t border-gray-100 ${isEven ? 'bg-gray-50' : 'bg-white'}`}
              >
                <div className="font-medium text-gray-800 border-r border-gray-200">{size}</div>
                <div className="font-bold text-blue-700 border-r border-gray-200">{priceValue} €</div>
                <div className="text-gray-700 break-words">{spotsText}</div>
              </div>
            );
          })}
        </div>
      </div>
        </div>
      </div>
    </div>
  );
};

export default PricesPage;